module.exports = __webpack_public_path__ + "img/hero-contact.be99ef72.jpg";